import posthog from "posthog-js";
import type { AnalyticsEvent, AnalyticsEventMap } from "./events";

const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY as string | undefined;
const IS_DEV = import.meta.env.DEV;

let initialized = false;

export function initAnalytics(): void {
  if (initialized || !POSTHOG_KEY) return;

  posthog.init(POSTHOG_KEY, {
    api_host: "https://eu.i.posthog.com",
    autocapture: false,
    capture_pageview: false,
    capture_pageleave: true,
    persistence: "localStorage+cookie",
    session_recording: {
      maskAllInputs: true,
      maskTextSelector: "[data-ph-no-capture]",
    },
    loaded: () => {
      if (IS_DEV) posthog.debug(false);
    },
  });

  initialized = true;
}

export function track<E extends AnalyticsEvent>(
  event: E,
  properties: AnalyticsEventMap[E],
): void {
  if (!initialized) return;
  posthog.capture(event, properties);
}

export function identifyUser(userId: string, properties?: Record<string, unknown>): void {
  if (!initialized) return;
  if (properties?.role === "ADMIN") {
    posthog.opt_out_capturing();
    return;
  }
  posthog.identify(userId, properties);
}

export function resetUser(): void {
  if (!initialized) return;
  if (posthog.has_opted_out_capturing()) {
    posthog.opt_in_capturing();
  }
  posthog.reset();
}
